module.exports = __webpack_public_path__ + "auth0.90b27e.svg";